// extracted by mini-css-extract-plugin
export default {"backdrop":"PreviewVideo_backdrop__Nm1L4","z_index_100":"PreviewVideo_z_index_100__cNsr8","close_video_icon":"PreviewVideo_close_video_icon__ulnIs"};